import { type FC } from "react";

import { Form } from "formik";

import { ApiEdit } from "../../../common/api-settings";
import { EndpointsEdit } from "../../../common/endpoints";

interface ApiSettingsForm {
    onSubmit: () => void;
}

export const ApiSettingsForm: FC<ApiSettingsForm> = ({ onSubmit }) => {
    return (
        <Form data-testid="remote-api-form" onSubmit={onSubmit}>
            <ApiEdit isUpdate={true} />
            <EndpointsEdit />
        </Form>
    );
};
